import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 L960,213.333333 C1371.62667,213.333333 1706.66667,548.266667 1706.66667,960 C1706.66667,1371.73333 1371.62667,1706.66667 960,1706.66667 C548.373333,1706.66667 213.333333,1371.73333 213.333333,960 C213.333333,762.986667 291.733333,577.493333 426.666667,439.253333 L426.666667,693.333333 L640,693.333333 L640,106.666667 L53.3333333,106.666667 L53.3333333,320 L244.373333,320 C88.64,494.08 0,720.96 0,960 C0,1489.28 430.613333,1920 960,1920 C1489.38667,1920 1920,1489.28 1920,960 C1920,430.72 1489.38667,0 960,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconResetSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconResetSolid, _Component);

  var _super = _createSuper(IconResetSolid);

  function IconResetSolid() {
    _classCallCheck(this, IconResetSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconResetSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReset",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconResetSolid.displayName = "IconResetSolid";
  return IconResetSolid;
}(Component);

IconResetSolid.glyphName = 'reset';
IconResetSolid.variant = 'Solid';
IconResetSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconResetSolid;
export { IconResetSolid };